import React, { useContext, useEffect, useState } from 'react';
import BasketRegular from 'jl-ui-kit/elements/icons/BasketRegular';

// eslint-disable-next-line import/no-named-as-default
import BasketAmount from '../basket-amount/BasketAmount';
import parseCookies from '../../../lib/cookie/parser';
import createUserProfileFrom from '../../../lib/cookie/user/profile';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';
import { UserContext } from '../../scaffold/UserContext';
import styles from './basket.scss';

const isClient = () => typeof window !== 'undefined' && window.document;
export default function Basket({ children: label }) {
  const [componentMounted, updateComponentMounted] = useState(false);

  const {
    envVars: { headerMinibasketActive },
  } = useContext(EnvVarsFeaturesContext);

  const {
    userState: {
      user: {
        basket: { items },
      },
    },
    updateUserState,
  } = useContext(UserContext);

  const handleUserProfileUpdate = () => {
    if (isClient()) {
      const cookies = parseCookies();
      const userProfile = createUserProfileFrom(cookies);
      updateUserState(userProfile);
    }
  };

  const handleBasketButtonClick = event => {
    if (isClient() && headerMinibasketActive && window.isMinibasketLoaded) {
      event.preventDefault();
      const customEvent = new global.window.CustomEvent(
        'jl-events.browser.showMinibasket',
        {
          detail: {
            source: 'page-level',
          },
        }
      );
      window.dispatchEvent(customEvent);
    }
  };

  useEffect(() => {
    if (!componentMounted) {
      window.addEventListener(
        'jl-events.browser.basketQuantityUpdated',
        handleUserProfileUpdate,
        false
      );
      updateComponentMounted(true);
    }

    return () => {
      window.removeEventListener(
        'jl-events.browser.basketQuantityUpdated',
        handleUserProfileUpdate,
        false
      );
    };
  }, []);

  return (
    <a
      id="minibasket-icon-anchor"
      className={styles.link}
      onClick={event => handleBasketButtonClick(event)}
      href="/basket"
      data-test="basket-anchor"
      aria-label="View your basket"
    >
      <BasketAmount basketItems={items} />
      <BasketRegular box />
      {label}
    </a>
  );
}
